export default {
  breakpoints: [
    '480px',
    '600px',
    '768px',
    '992px',
    '1200px',
    '1366px',
    '1680px',
  ],
  colors: {
    green: '#36d57d',
    greenLight: '#a5ecc5',
    geyser: '#cfdce1',
    grey: '#4d5356',
    greyDark: '#3d4251',
    greyLight: '#d1d3d8',
    greyLighter: '#e6eaeb',
    greyOslo: '#859094',
    orange: '#ff9400',
    orangeDark: '#ad662c',
    porcelain: '#f0f4f5',
    primary: '#33aacc',
    primaryDark: '#263e63',
    primaryDarker: '#14243e',
    primaryDarkest: '#0c1626',
    primaryLight: '#7ecce2',
    primaryLighter: '#d5eaef',
    primaryLightest: '#ebf4f7',
    purple: '#8468c4',
    purpleDark: '#5d488c',
    purpleLight: '#a786f3',
    raven: '#737a80',
    red: '#fe5c5c',
    redLight: '#ffb5b5',
    secondary: '#ffc844',
    secondaryLight: '#fbe28d',
    white: '#ffffff',
    blackTransparent: 'rgba(0, 0, 0, 0.2)',
    whiteTransparent: 'rgba(255, 255, 255, 0.2)',
  },
  fonts: {
    body: "Lato, -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif",
    heading: "Lato, -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif",
    monospace:
      "Lato, -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif",
  },
  fontWeights: {
    bold: 700,
    body: 400,
    heading: 700,
  },
  fontSizes: [
    '16px',
    '2.5rem',
    '2rem',
    '1.5rem',
    '1.25rem',
    '1.125rem',
    '1rem',
    '0.875rem',
    '0.75rem',
  ],
  lineHeights: {
    body: '1.5',
    heading: '1.25',
    single: '1',
  },
  radii: ['4px', '50%'],
  shadows: {
    border: '0 0 0 1px #e6eaeb',
    color: 'rgba(0, 0, 0, 0.15)',
    lg: '0 3px 5px 0 rgba(0, 0, 0, 0.15)',
    md: '0 1px 3px 0 rgba(0, 0, 0, 0.15)',
    sm: '0 1px 2px 0 rgba(0, 0, 0, 0.15)',
    xl: '0 4px 8px 0 rgba(0, 0, 0, 0.15)',
    xlGreen: '0 4px 8px 0 rgba(54, 213, 125, 0.3)',
    xlOrange: '0 4px 8px 0 rgba(255, 148, 0, 0.3)',
    xlPurple: '0 4px 8px 0 rgba(132, 104, 196, 0.3)',
    xxl: '0 10px 20px 0 rgba(0, 0, 0, 0.15)',
  },
  styles: {
    root: {
      background: '#000000',
    },
  },
};
